import React from 'react'
import PropTypes from 'prop-types'

import { SearchInput } from 'components/input/searchInput/SearchInput'

import styles from './DefaultSearchRenderer.module.scss'

export const DefaultSearchRenderer =
  ({
    debounceTimeout,
    handleClear,
    handleInputChange,
    handleSearch,
    isAutoFocus,
    searchString,
    searchPlaceholder,
    searchLimit,
  }) =>
  () => {
    if (!handleSearch) {
      return null
    }

    return (
      <SearchInput
        className={styles.search}
        isAutoFocus={isAutoFocus}
        limit={searchLimit}
        onChange={handleInputChange}
        onSearch={handleSearch}
        onClear={handleClear}
        placeholder={searchPlaceholder}
        value={searchString}
        debounceTimeout={debounceTimeout}
      />
    )
  }

DefaultSearchRenderer.propTypes = {
  debounceTimeout: PropTypes.number,
  handleClear: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  isAutoFocus: PropTypes.bool,
  searchString: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  searchLimit: PropTypes.number,
  setInputRef: PropTypes.func.isRequired,
}
